import tw, { styled } from 'twin.macro';

export const StyledTabTitle = styled.div<{ isActive: boolean }>`
  ${tw`font-inter`}
  ${tw`text-primary-p1 text-nowrap`}
  ${tw`border-b border-ui-colours-ui3`}
  ${tw`pb-[10px] px-1`}
  ${tw`relative`}

  ${({ isActive }) =>
    isActive ? tw`font-semi-bold border-secondary-s1` : tw`border-ui-colours-ui3`}

  &:hover {
    ${tw`border-secondary-s1`}
  }

  &::after {
    content: attr(data-text);
    font-weight: 600;
    height: 0;
    visibility: hidden;
    overflow: hidden;
    user-select: none;
    pointer-events: none;
    display: block;
  }
`;

export const StyledTabs = styled.div`
  ${tw`container`}
  .swiper {
    ${tw`mb-2`}
  }
  .swiper-wrapper {
    ${tw`justify-around lg:justify-center`}
  }
  .swiper-slide {
    ${tw`!shrink`}
    ${tw`w-fit`}
    ${tw`cursor-pointer`}
    & li:focus {
      outline: none;
    }
  }
`;

export const StyledContent = styled.div<{ isActive: boolean }>`
  ${tw`-mx-2 lg:mx-0`};
  ${({ isActive }) => !isActive && tw`hidden`}
`;
